import styled from 'astroturf/react';
import InputMask from 'react-input-mask';

const textField = styled('label')`
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  margin-bottom: 15px;

  & + & {
    border-top: 0;
  }

  &.auth {
    border: none;
    flex-direction: column;
  }

  &.rounded {
    border: none;
  }

  & > input::placeholder,
  & > textarea::placeholder {
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: var(--ph-gray-500);
  }

  &.invisible {
    border: 0;

    & > div {
      border-right: 0;
      padding-left: 0;
    }

    & > input,
    & > textarea {
      background-color: var(--white);
      border-radius: var(--ph-border-radius-sm);
    }

    &.withPaddingLeft > div {
      padding-left: 20px;
    }
  }
`;

const textFieldLabel = styled('div')`
  font-size: var(--ph-text-sm);
  display: flex;
  justify-content: space-between;
  flex: 0 0 30%;
  line-height: 1.54;
  align-items: center;
  color: var(--ph-gray-500);
  min-width: 100px;
  cursor: pointer;

  &.auth {
    border-right: none;
    padding: 0;
    margin-bottom: 5px;
    color: var(--ph-gray-500);
    cursor: pointer;
  }
`;

const textFieldInput = styled('input')`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  transition: var(--ph-transition);
  outline: none;
  appearance: none;
  font-size: var(--ph-text-sm);
  padding-left: 5px;
  padding-right: 5px;
  height: 30px;
  border-radius: var(--ph-border-radius-sm);
  border-width: 1px;
  border-style: solid;
  border-image: initial;
  border-color: var(--ph-gray-100);
  background-color: var(--white);
  color: var(--black);

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
    border: var(--ph-gray-200) 1px solid;
  }

  &.error {
    box-shadow: 0 0 0 1px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }

  &.spaced {
    letter-spacing: 6px;
  }

  &.rounded {
    border-radius: var(--ph-border-radius-sm);
    flex: 0 0 100%;
    height: 30px;
    padding-left: 30px;

    &:focus {
      border: none;
    }
  }

  &.auth {
    flex: auto;
  }

  &.fullwidth {
    flex: 0 0 100%;
  }

  &.disabledField {
    cursor: not-allowed !important;
    background-color: var(--ph-gray-50) !important;
    border: 1px solid var(--ph-gray-100) !important;
    color: var(--ph-gray-300) !important;
  }
`;

const textFieldArea = styled('textarea')`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  outline: none;
  appearance: none;
  font-size: var(--ph-text-sm);
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  height: 100px;
  border-radius: var(--ph-border-radius-sm);
  border-width: 1px;
  border-style: solid;
  border-image: initial;
  border-color: var(--ph-gray-100);
  background-color: var(--white);
  color: var(--black);
  min-height: 80px;
  resize: vertical;

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

  &.error {
    box-shadow: 0 0 0 1px var(--ph-red-500);
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }

  &.spaced {
    letter-spacing: 6px;
  }

 
  &.disabledField {
    cursor: not-allowed !important;
    background-color: var(--ph-gray-50) !important;
    border: 1px solid var(--ph-gray-100) !important;
    color: var(--ph-gray-300) !important;
  }
`;

const textFieldRequired = styled('span')`
  position: relative;
  top: 2px;
  color: var(--ph-red-500);
`;

const textFieldError = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--ph-red-500);
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0%, -50%);
  text-align: right;
  pointer-events: none;
  text-transform: initial;

  &.auth {
    top: 12px;
    right: 0;
  }
`;

const TextFieldInputMask = styled(InputMask)`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  transition: var(--ph-transition);
  outline: none;
  appearance: none;
  font-size: var(--ph-text-sm);
  padding-left: 5px;
  padding-right: 5px;
  height: 30px;
  border: 1px solid var(--ph-gray-100);
  border-radius: var(--ph-border-radius-sm);
  border-image: initial;
  background-color: var(--white);
  color: var(--black);

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
    border: var(--ph-gray-200) 1px solid;
  }

  &.error {
    box-shadow: 0 0 0 1px var(--ph-red-500);
  }

  &.spaced {
    letter-spacing: 6px;
  }

  &.rounded {
    border-radius: var(--ph-border-radius-sm);
    flex: 0 0 100%;
    height: 30px;
    padding-left: 30px;

    &:focus {
      border: none;
    }
  }

  &.auth {
    flex: auto;
  }

  &.fullsize {
    flex: 0 0 100%;
  }
`;

export default {
  TextField: textField,
  TextFieldLabel: textFieldLabel,
  TextFieldError: textFieldError,
  TextFieldInput: textFieldInput,
  TextFieldRequired: textFieldRequired,
  TextFieldArea: textFieldArea,
  TextFieldInputMask,
};
